import { ELEMENT_TYPE, FEATURE_FLAG_KEYS, LAYOUT_SECTION_NAME } from 'shop-ui/constants';
import {
    headerLayoutFeatures,
    primaryLevelGridFeatures,
    secondaryLevelGridFeatures,
    innerSecondaryLevelGridFeatures,
} from 'shop-ui/section/Grid/define';
import { features as searchBarFeatures } from 'shop-ui/component/SearchBar/define';
import { features as richTextFeatures } from 'shop-ui/component/RichText/define';
import { features as productSuggestionFeatures } from 'shop-ui/component/ProductSuggestion/define';
import { features as productPromoInfoFeatures } from 'shop-ui/component/ProductPromoInfo/define';
import { features as productInfoGroupFeatures } from 'shop-ui/component/ProductInfoGroup/define';
import { features as productImageGalleryFeatures } from 'shop-ui/component/ProductImageGallery/define';
import { features as productGroupFeatures } from 'shop-ui/component/ProductGroup/define';
import { features as productGiveawayFeatures } from 'shop-ui/component/ProductGiveaway/define';
import { features as productDescriptionFeatures } from 'shop-ui/component/ProductDescription/define';
import { features as menuFeatures } from 'shop-ui/component/Menu/define';
import { features as mediaFeatures } from 'shop-ui/component/Media/define';
import { features as logoFeatures } from 'shop-ui/component/Logo/define';
import { features as headerCartIconFeatures } from 'app/shop-ui/component/HeaderCartIcon/define';
import { features as headerLoginIconFeatures } from 'app/shop-ui/component/HeaderLoginIcon/define';
import { features as footerKYCFeatures } from 'shop-ui/component/FooterKYC/define';
import { features as dividerFeatures } from 'shop-ui/component/Divider/define';
import { features as carouselFeatures } from 'shop-ui/component/Carousel/define';
import { features as buttonFeatures } from 'shop-ui/component/Button/define';
import { features as breadcrumbFeatures } from 'shop-ui/component/Breadcrumb/define';
import { features as productShippingDetailFeatures } from 'shop-ui/component/ProductShippingDetail/define';
import i18n from '@shared/i18n';

export const featureFlagData = {
    [ELEMENT_TYPE.GRID_PRIMARY_LEVEL]: primaryLevelGridFeatures,
    [ELEMENT_TYPE.GRID_SECONDARY_LEVEL]: secondaryLevelGridFeatures,
    [ELEMENT_TYPE.GRID_SECONDARY_LEVEL_INNER]: innerSecondaryLevelGridFeatures,
    [ELEMENT_TYPE.SEARCH_BAR]: searchBarFeatures,
    [ELEMENT_TYPE.RICH_TEXT]: richTextFeatures,
    [ELEMENT_TYPE.PRODUCT_SUGGESTION]: productSuggestionFeatures,
    [ELEMENT_TYPE.PRODUCT_PROMO_INFO]: productPromoInfoFeatures,
    [ELEMENT_TYPE.PRODUCT_INFO_GROUP]: productInfoGroupFeatures,
    [ELEMENT_TYPE.PRODUCT_IMAGE_GALLERY]: productImageGalleryFeatures,
    [ELEMENT_TYPE.PRODUCT_GROUP]: productGroupFeatures,
    [ELEMENT_TYPE.PRODUCT_GIVEAWAY]: productGiveawayFeatures,
    [ELEMENT_TYPE.PRODUCT_DESCRIPTION]: productDescriptionFeatures,
    [ELEMENT_TYPE.PRODUCT_SHIPPING_DETAIL]: productShippingDetailFeatures,
    [ELEMENT_TYPE.MENU]: menuFeatures,
    [ELEMENT_TYPE.IMAGE]: mediaFeatures,
    [ELEMENT_TYPE.VIDEO]: mediaFeatures,
    [ELEMENT_TYPE.LOGO]: logoFeatures,
    [ELEMENT_TYPE.HEADER_CART_ICON]: headerCartIconFeatures,
    [ELEMENT_TYPE.HEADER_LOGIN_ICON]: headerLoginIconFeatures,
    [ELEMENT_TYPE.FOOTER_KYC_AREA]: footerKYCFeatures,
    [ELEMENT_TYPE.DIVIDER]: dividerFeatures,
    [ELEMENT_TYPE.CAROUSEL]: carouselFeatures,
    [ELEMENT_TYPE.BUTTON]: buttonFeatures,
    [ELEMENT_TYPE.BREADCRUMB]: breadcrumbFeatures,
} as const;

export const componentLocalizedName = {
    [ELEMENT_TYPE.PRODUCT_PROMO_INFO]: i18n.gettext('優惠資訊'),
    [ELEMENT_TYPE.PRODUCT_DESCRIPTION]: i18n.gettext('商品段落'),
    [ELEMENT_TYPE.PRODUCT_SHIPPING_DETAIL]: i18n.gettext('物流及運費說明'),
};

export const defaultSiteStyle = {
    [FEATURE_FLAG_KEYS.SITE_PAGE_HEADER_ENABLED]: true,
    [FEATURE_FLAG_KEYS.SITE_WIDTH]: 'large',
    [FEATURE_FLAG_KEYS.SITE_WIDTH_CUSTOM]: '',
    [FEATURE_FLAG_KEYS.SITE_BACKGROUND_COLOR]: '',
    [FEATURE_FLAG_KEYS.SITE_BACKGROUND_TYPE]: 'color',
    [FEATURE_FLAG_KEYS.SITE_BACKGROUND_COLOR_GRADIENT]: '',
};

export const getFeatureFlagData = (
    type: ELEMENT_TYPE,
    sectionName: LAYOUT_SECTION_NAME
): FEATURE_FLAG_KEYS[] => {
    if (
        sectionName === LAYOUT_SECTION_NAME.HEADER &&
        type === ELEMENT_TYPE.GRID_PRIMARY_LEVEL
    ) {
        return headerLayoutFeatures;
    }

    return featureFlagData?.[type] || [];
};
